import logo from "../../assets/brand/logo_background.png";
import { Image } from "antd";

const clean = (v) =>
  typeof v === "string" ? v.replace(/,+\s*$/g, "").trim() : v ?? "";
export function FallbackImage({ src, ...imgProps }) {
  const FALLBACK = logo;
  return (
    <Image
      {...imgProps}
      src={clean(src)}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = clean(FALLBACK);
      }}
    />
  );
}
